import { render, staticRenderFns } from "./raise-ticket.vue?vue&type=template&id=5754251c&scoped=true&"
import script from "./raise-ticket.vue?vue&type=script&lang=js&"
export * from "./raise-ticket.vue?vue&type=script&lang=js&"
import style0 from "./raise-ticket.vue?vue&type=style&index=0&id=5754251c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5754251c",
  null
  
)

export default component.exports